<template>
  <v-select
    v-model="item"
    :items="items"    
    :loading="isLoading"
    :error-messages="error"    
    label="Status de Pagamento"    
    item-text="label"
    item-value="raw"
    clearable
    outlined
    dense    
    @input="$emit('input', item)"
  />
</template>

<script>
  import paymentService from '@/services/pagamentos.service';

  export default {
    name: 'SearchOrderPaymentStatusSelect',

    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      isLoading: false,
      error: null,
      items: [],
      item: null
    }),

    mounted() {
      this.item = this.value;

      this.fetch();
    },

    methods: {
      fetch() {
        this.isLoading = true;
        paymentService.listStatus().subscribe((response) => {
          this.items = response;
          this.isLoading = false;
        }, () => {
          this.error = 'Erro ao carregar os status de pagamento';
          this.isLoading = false;
        });
      },      
    }
  };
</script>
